<div>
  <a [routerLink]="postLink" class="card clickable">
    <div class="card-img">
      <img [src]="postImage" [alt]="'planse de colorat biblice pentru copii cu ' + postData.title.rendered"/>
    </div>
    <div class="card-block">
      <div class="card-title" [innerHTML]="postData.title.rendered"></div>
      <div class="card-tags">
        <span class="tag mr-1 py-1 px-2" *ngFor="let tag of maxTags">{{tag}}</span>
        <div class="tag-gradient text-right"><fa-icon icon="angle-right"></fa-icon></div>
      </div>
      <p class="card-text">
        <b>{{postData.allImages.length}}</b> imagini în această colecție
      </p>
    </div>
  </a>
</div>
